module.exports = __webpack_public_path__ + "img/course_blank.21e995c0.jpg";